import { Injectable } from '@angular/core';
// import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';

import { SessionService } from '../session.service';
import { QuestionPageDetailsResponseJSON } from './../common/JSON/questionPage/Question-Page-Details-Response.JSON';
import { SurveyDeployerQuestionPageRequestJSON } from './../common/JSON/RequestTOJSON/Survey-Deployer-Question-Page-Request.JSON';
import { QuestionPageDetailsRequestJSON } from './../common/JSON/questionPage/Question-Page-Details-Request.JSON';
import { Observable } from 'rxjs';
@Injectable()
export class QuestionPageService {

    private fetchQuestionDetailsRestServicePath: string;
    private actionURL: string;
    private generateURL: string;
    private saveWCPUrl: string;
    private getQPUrl: string;
    private saveQPUrl:string;
    private submitQPUrl:string;
    
    request: SurveyDeployerQuestionPageRequestJSON;
    requestSubmit: QuestionPageDetailsRequestJSON;

    

    constructor(private http: HttpClient,private sessionService: SessionService) {
        // this.generateURL = this.sessionService.baseURL+"/services/altSurveyDeployer/generate";
        // this.saveWCPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/saveWelcomePageInfo";
        // this.getQPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/questionsDetail";
        // this.saveQPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/saveQuestionResponseDetails";
    }

    private urlMappings(){
        this.generateURL = this.sessionService.baseURL+"/services/altSurveyDeployer/generate";
        this.saveWCPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/saveWelcomePageInfo";
        this.getQPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/questionsDetail";
        this.saveQPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/saveQuestionResponseDetails";
        this.submitQPUrl = this.sessionService.baseURL+"/services/altSurveyDeployer/submitQuestionResponseDetails";
    }

    private getHeaders() {
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        return headers;
    }

    private getHeaders2() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/plain');
    return headers;
    }

    fetchQuestions(surveyDeployerQuestionPageRequestJSON: SurveyDeployerQuestionPageRequestJSON): Observable<any> {
        const headers = this.getHeaders2();
        this.request = surveyDeployerQuestionPageRequestJSON;
        this.urlMappings();
        return this.http.post(this.getQPUrl, JSON.stringify(this.request), {headers})
            .timeout(200000);

    }

    saveQuestions(questionPageDetailsRequestJSON: QuestionPageDetailsRequestJSON): Observable<any>{
        let headers = this.getHeaders2();
        this.requestSubmit = questionPageDetailsRequestJSON;
        this.urlMappings();
        return this.http.post(this.saveQPUrl, JSON.stringify(questionPageDetailsRequestJSON), {headers})
            .timeout(200000);

    }

    submitQuestions(questionPageDetailsRequestJSON: QuestionPageDetailsRequestJSON): Observable<any>{
        let headers = this.getHeaders2();
        this.requestSubmit = questionPageDetailsRequestJSON;
        this.urlMappings();
        return this.http.post(this.submitQPUrl, JSON.stringify(questionPageDetailsRequestJSON), {headers})
            .timeout(200000);

    }

}